<!--  -->
<template>
  <div :class="['menu',{'fixed':isSetFixed}]" :style="setBackColor">
    <router-link
      tag="div"
      v-for="(item, i) in routeList"
      :to="item.path"
      :key=i
      class="menu__link"
      :style="[item.path === $route.path ? setStyle('main','color') : setDefaultStyle('main','color')]"
      exact-active-class="title-active"
    >
      {{item.name}}
      <i class="nav_list_link_line"
          :style="setStyle('vice','backgroundColor')"
          v-show="item.path === $route.path">
      </i>
    </router-link>
    <div class="menu__line" :style="setBgColor()"></div>
  </div>
</template>

<script>
import { setColor } from '../utils/style';
import { mapGetters } from 'vuex'
const BANNER_HEIGHT = 400
export default {
  props: {
    routeList: {
        type: Array,
        default: () => []
    },
    globalConfig:{
      type:Object,
      default:()=>{}
    }
  },
  computed:{
    ...mapGetters([
      'loginStatus',
    ]),
    setBackColor(){
      if(this.isSetFixed){
        return{
          backgroundColor:this.globalConfig.bg.value
        }
      }
      return true;
      
    }
  },
  data(){
    return{
      isSetFixed:false,
      timer:null
    }
  },
  methods:{
    setStyle(key, type) {
      return setColor(this.globalConfig, key, type);
    },
    setDefaultStyle(){
      // let color = setColor(this.globalConfig, key, type);
      // console.log()
      // return{
      //   'color':color,
      //   opacity:0.5
      // }
      return{
        'color':this.globalConfig.main,
        opacity:0.8
      }
    },
    setBgColor() {
      if (this.globalConfig && this.globalConfig.vice) {
        return {
          background: `linear-gradient(90deg, ${this.globalConfig.bg.value} 0%,${this.globalConfig.vice} 50%, ${this.globalConfig.bg.value} 100%)`,
        };
      }
    },
    getScrollTop() {
      const scrollTop = window.pageYOffset
      || document.documentElement.scrollTop
      || document.body.scrollTop;
      return scrollTop;
    },
    setFixed(){
      this.isSetFixed = this.getScrollTop() > BANNER_HEIGHT ? true : false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.setFixed);
  },
  beforeDestroy() {
    if(this.timer) clearTimeout(this.timer)
    this.timer = null;
  },

}

</script>
<style lang='less' scoped>
.menu {
  position: absolute;
  top:0;
  left:0;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 98px;
  color:#fff;
  padding-top:42px;
  &.fixed{
    position: fixed;
    top:0;
    left:0;
    z-index: 99;
  }
  &__line {
    position: absolute;
    top: 86px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, #000000 0%, #F19600 51%, #202020 100%);
  }
  &__link {
    margin: 0 35px;
    font-size: 24px;
    font-weight: 500;
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      cursor: pointer;
      // color:rgba(256, 256, 256, .6)
    }
  }
}
.title-active {
  position: relative;
  // color: #fff;
  font-size: 28px;
  font-weight: 500;
  transition: all 1s;
}
.nav_list_link_line{
  width: 80%;
  height: 4px;
  position: absolute;
  bottom:2px;
  left:50%;
  transform: translate(-50%,0);
  border-radius: 3px;
}
</style>